// @TODO: Extend with global error messages depending on validation prop
// @TODO: Extend to accept matches options (see alphaValidation example below)
// @TODO: Cleanup examples & comments when done

import * as Yup from "yup";

import getInputs from "./getInputs";

// const validationExamples = Yup.object().shape({
//     emailValidation: Yup.string().email('Unesite ispravan email').required('Obvezno polje'),
//     alphaValidation: Yup.string().matches(alpha, { message: 'Samo slova', excludeEmptyString: true }),
//     alphaNumValidation: Yup.string().matches(alphaNum, { message: 'Slova i brojevi', excludeEmptyString: true }),
//     numberValidation: Yup.number().typeError('Unesite broj')
// })

// Regex
// const alpha = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/
// const alphaNum = /^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/
// const email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

// Global error messages
const errorMessage = {
    required: "Neophodno!",
    email: "Unesite ispravan email",
    number: "Unesite broj",
};

const createYupSchema = (schema, config) => {
    const { id, validationType, validationTypeError, validations = [] } = config;
    if (!Yup[validationType]) {
        return schema;
    }
    let validator = Yup[validationType]().typeError(
        validationTypeError || errorMessage[validationType],
    );
    validations.forEach((validation) => {
        const { params = [], type } = validation;
        if (!validator[type]) {
            return;
        }
        const messages = [errorMessage[type]];
        validator = validator[type](...params, ...messages);
    });
    schema[id] = validator;
    return schema;
};

const getFormValidation = (fields) => {
    const inputs = getInputs(fields);
    const yupSchema = inputs.reduce(createYupSchema, {});
    return Yup.object().shape(yupSchema);
};

export default getFormValidation;
